<template>
  <div class="mb-4" v-if="nrePage.nreData">

    <!--#region -- Content ---->

    <div class="stage-header border-bottom mb-4">
      <!--#region Header-->
      <div class="caption-label">Basic Information</div>
      <div class="row mb-4">
        <div class="col-4">
          <div class="header-col">
            <div>FTIE ID</div>
            <div>{{ basic_info_review.ftie_id }}</div>
          </div>
          <div class="header-col">
            <div>ETO NRE</div>
            <div>{{ basic_info_review.nre_id }}</div>
          </div>
          <div class="header-col">
            <div>Salesforce ES</div>
            <div>{{ basic_info_review.sales_force_es_no }}</div>
          </div>
        </div>
        <div class="col-4">
          <div class="header-col">
            <div>Salesforce Opportunity</div>
            <gtc-opportunity :opportunityId="basic_info_review.sales_force_opty_id"
                             :opportunityName="basic_info_review.sales_force_opty" />
          </div>
          <div class="header-col">
            <div>Account Name</div>
            <div>{{ basic_info_review.account }}</div>
          </div>
        </div>
        <div class="col-4">
          <div class="header-col">
            <div>Product</div>
            <div>{{ basic_info_review.nre_model }}</div>
          </div>
          <div class="header-col">
            <div>Customization SKU ID</div>
            <div>{{ basic_info_review.sku_id }}</div>
          </div>
        </div>
      </div>
      <!--#endregion Header-->
    </div>
    <!--#endregion-->
    <!--#region Customization Proposal-->
    <div class="stage-header border-bottom mb-4">
      <div class="stage-body-customization-proposal">
        <div class="caption-label">Customization Proposal</div>
        <div>
          <gtc-froala :read-only="true" v-model="nre_estimation_curr_stage.customization_proposal" />
        </div>
      </div>
      <div><br /><br /></div>
    </div>
    <!--#endregion: Customization Proposal-->
    <div style="margin-bottom: 6rem;">
      <div class="border-bottom pb-4 mb-4">
        <div class="row">
          <div class="col-auto" style="min-width: 60rem;">
            <!--#region NRE Estimation-->
            <div class="stage-body-nre-estimation">
              <div class="caption-label">NRE Estimation</div>
              <div>
                <div class="header-col">
                  <div>Module</div>
                  <div class="flex-fill">
                    <gtc-text-box :read-only="true" class="" v-model="nre_estimation_curr_stage.module" />
                  </div>
                </div>
                <div class="header-col">
                  <div>PoC Required</div>
                  <div>
                    {{ nre_estimation_curr_stage.poc_required === 'Y' ? 'Yes' : 'No' }}
                  </div>
                </div>
                <!--#region Table-->
                <div class="mt-3">
                  <table class="table nre-estimation-table table-sm">
                    <colgroup>
                      <col style="width: 1px;" />
                      <col style="width: 1px;" />
                      <col />
                      <col style="width: 6rem;" />
                      <col style="width: 6rem;" />
                    </colgroup>
                    <thead class="text-dark thead-light">
                      <tr>
                        <th>Category</th>
                        <th colspan="2">Item</th>
                        <th>{{ $attrs.pocWordingGRO }}</th>
                        <th>{{ $attrs.mpWordingGRO }}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <!--#region Labor Cost-->
                      <tr>
                        <td rowspan="2">Labor Cost</td>
                        <td colspan="2">Development</td>
                        <td rowspan="2"><gtc-number :read-only="true" class="text-right" v-model="nre_estimation_curr_stage.labor_cost.poc_cost" /></td>
                        <td rowspan="2"><gtc-number :read-only="true" v-model="nre_estimation_curr_stage.labor_cost.mp_cost" /></td>
                      </tr>
                      <tr>
                        <td colspan="2">Verification</td>
                      </tr>
                      <!--#endregion-->
                      <!--#region Test Sample-->
                      <tr>
                        <td rowspan="1">Test Sample</td>
                        <td colspan="2">
                          EQT Test Sample
                        </td>
                        <td><gtc-number :read-only="true" class="text-right" v-model="nre_estimation_curr_stage.test_sample.poc_cost" /></td>
                        <td><gtc-number :read-only="true" class="text-right" v-model="nre_estimation_curr_stage.test_sample.mp_cost" /></td>
                      </tr>
                      <!--
                  <tr>
                    <td colspan="2">
                      <div class="row align-items-center">
                        <div class="col">B. Sharing rate</div>
                        <div class="col-auto ml-auto">
                          <gtc-number :read-only="true" class="min-w-6" v-model="nre_estimation_curr_stage.test_sample.sharing_rate" />
                        </div>
                        <div class="col-auto pl-0" style="width: 3rem">%</div>
                      </div>
                    </td>
                  </tr>
                      -->
                      <!--#endregion-->
                      <!--#region Job Cost-->
                      <tr>
                        <td rowspan="5">Job Cost</td>
                        <td colspan="2">Tooling Fee</td>
                        <td rowspan="5"><gtc-number :read-only="true" v-model="nre_estimation_curr_stage.job_cost.poc_cost" /></td>
                        <td rowspan="5"><gtc-number :read-only="true" v-model="nre_estimation_curr_stage.job_cost.mp_cost" /></td>
                      </tr>
                      <tr>
                        <td colspan="2">PCB Fabrication Fee</td>
                      </tr>
                      <tr>
                        <td colspan="2">Test Jig / Fixture</td>
                      </tr>
                      <tr>
                        <td colspan="2">Outsource Fee</td>
                      </tr>
                      <tr>
                        <td colspan="2">
                          <div class="row mx-n1">
                            <div class="px-1 col-auto">Others - </div>
                            <div class="px-1 col">
                              <pre class="mb-0 font-size-base font-family-base">{{ nre_estimation_curr_stage.job_cost.remark }}</pre>
                            </div>
                          </div>
                        </td>
                      </tr>

                      <!--#endregion-->
                      <!--#region Regulation-->
                      <tr>
                        <td rowspan="4">Regulation</td>
                        <td colspan="2">
                          <div class="row mx-n1">
                            <div class="px-1 col-auto">EMC - </div>
                            <div class="px-1 col">
                              <pre class="mb-0 font-size-base font-family-base">{{ nre_estimation_curr_stage.regulation.emc_remark }}</pre>
                            </div>
                          </div>
                        </td>
                        <td rowspan="4"><gtc-number :read-only="true" v-model="nre_estimation_curr_stage.regulation.regulation_others.poc_cost" /></td>
                        <td rowspan="4"><gtc-number :read-only="true" v-model="nre_estimation_curr_stage.regulation.regulation_others.mp_cost" /></td>
                      </tr>
                      <tr>
                        <td colspan="2">
                          <div class="row mx-n1">
                            <div class="px-1 col-auto">Safety - </div>
                            <div class="px-1 col">
                              <pre class="mb-0 font-size-base font-family-base">{{ nre_estimation_curr_stage.regulation.safety_remark }}</pre>
                            </div>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td colspan="2">
                          <div class="row mx-n1">
                            <div class="px-1 col-auto">Environmental - </div>
                            <div class="px-1 col">
                              <pre class="mb-0 font-size-base font-family-base">{{ nre_estimation_curr_stage.regulation.environment_remark }}</pre>
                            </div>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td colspan="2">
                          <div class="row mx-n1">
                            <div class="px-1 col-auto">Others - </div>
                            <div class="px-1 col">
                              <pre class="mb-0 font-size-base font-family-base">{{ nre_estimation_curr_stage.regulation.regulation_others.remark }}</pre>
                            </div>
                          </div>
                        </td>
                      </tr>

                      <!--#endregion-->
                      <!--#region Others-->

                      <tr>
                        <td colspan="2">
                          <div class="row mx-n1">
                            <div class="px-1 col-auto">Others - </div>
                            <div class="px-1 col">
                              <pre class="mb-0 font-size-base font-family-base">{{ nre_estimation_curr_stage.others.remark }}</pre>
                            </div>
                          </div>
                        </td>
                        <td></td>
                        <td><gtc-number :read-only="true" v-model="nre_estimation_curr_stage.total_cost.poc_cost" /></td>
                        <td><gtc-number :read-only="true" v-model="nre_estimation_curr_stage.total_cost.mp_cost" /></td>
                      </tr>

                      <!--#endregion-->
                    </tbody>
                    <tfoot>
                      <tr>
                        <td>Total NRE</td>
                        <td></td>
                        <td></td>
                        <td class="text-right font-weight-normal font-size-base">{{ nre_estimation_total_poc_cost_curr_stage | comma }}</td>
                        <td class="text-right font-weight-normal font-size-base">{{ nre_estimation_total_mp_cost_curr_stage  | comma }}</td>
                      </tr>
                    </tfoot>
                  </table>
                </div>
                <!--#endregion-->
              </div>
            </div>
            <!--#endregion-->
          </div>
          <div class="col">
            <!--#region Project Proposal File-->
            <div class="stage-body-project-proposal-file mt-3">
              <div class="caption-label d-flex">
                <div>Project Proposal File</div>
              </div>
              <div>
                <b-table small thead-class="thead-light text-dark"
                         :items="proposal_files" :fields="nrePage.projectProposalFileSetting">
                  <template #cell(file_name)="data">
                    <a herf="#" class="file" @click="$emit('getFile',data.item)">{{data.item.file_name}}</a>
                  </template>
                  <template #cell(update_time)="data">
                    {{ data.item.update_time | dateTimeFormat }}
                  </template>
                </b-table>
              </div>
            </div>
            <!--#endregion-->
          </div>
        </div>
      </div>
      <!-- Region: Ref SKU Info -->
      <div class="stage-header border-bottom mb-4">
        <div class="caption-label">Reference(Standard) SKU Price Information</div>
        <div class="row mb-4">
          <div class="col-4">
            <div class="row">
              <div class="col-auto">
                <div class="header-col">
                  <div>Standard SKU ID</div>
                  <div>{{ _.get(skuItem, 'sku_id', '') }}</div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-4">
            <div class="header-col">
              <div>Distributor Price</div>
              <div>{{$attrs.currencySign}} {{ _.get(skuItem, 'price_info.distributor_price', '') | comma }}</div>
            </div>
            <div class="header-col">
              <div>Reseller Price</div>
              <div>{{$attrs.currencySign}} {{ _.get(skuItem, 'price_info.reseller_price', '') | comma }}</div>
            </div>
            <div class="header-col">
              <div>MSRP</div>
              <div>{{$attrs.currencySign}} {{ _.get(skuItem, 'price_info.msrp', '') | comma }}</div>
            </div>
          </div>
        </div>
      </div>
      <!--#endregion: ref sku info-->
      <!--#region Cost Per Unit Estimation-->
      <div class="stage-body-cost-per-unit-estimation border-bottom pb-4 mb-4">
        <div class="caption-label">Cost Per Unit Estimation</div>
        <div>
          <table class="table table-sm cost-per-unit-estimation-table">
            <colgroup>
              <col style="width:1px;" />
              <col style="width:6rem;" />
              <col style="width:6rem;" />
              <col />
            </colgroup>
            <thead class="text-dark thead-light">
              <tr>
                <th class="text-nowrap">Category</th>
                <th class="text-nowrap">{{ $attrs.pocWordingGRO }}</th>
                <th class="text-nowrap">{{ $attrs.mpWordingGRO }}</th>
                <th class="text-nowrap">Remark</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Demand Quantity</td>
                <td><gtc-number :read-only="true" v-model="unit_estimation_curr_stage.demand_quantity.poc_cost" :decimalLen="0" /></td>
                <td><gtc-number :read-only="true" v-model="unit_estimation_curr_stage.demand_quantity.mp_cost" :decimalLen="0" /></td>
                <td><gtc-text-box :read-only="true" class="" v-model="unit_estimation_curr_stage.demand_quantity.remark" /></td>
              </tr>
              <tr>
                <td>
                  <div>(A) NRE Amortization / Per unit (for MP)</div>
                  <div class="p-tab d-flex align-items-center">
                    <b-form-checkbox v-model="unit_estimation_curr_stage.nre_amortization.nre_amortization_check"
                                     :disabled="true"
                                     @change="unit_estimation_curr_stage.nre_amortization.nre_amortization_quantity = 0"
                                     value="Y" unchecked-value="N">NRE Amortization Quantity:</b-form-checkbox>

                    <gtc-number :read-only="true"
                                :decimalLen="0" class="ml-2 min-w-5"
                                v-model="unit_estimation_curr_stage.nre_amortization.nre_amortization_quantity" />
                  </div>
                </td>
                <td class="text-center">–</td>
                <td><gtc-number :read-only="true" v-model="unit_estimation_curr_stage.nre_amortization.nre_amortization_cost" /></td>
                <td class="px-2">–</td>
              </tr>
              <tr>
                <td>
                  <div>(B) Cost of Base unit</div>
                  <div class="p-tab d-flex align-items-center">
                    <div>Reference PN:</div>
                    <div class="ml-2">{{ unit_estimation_curr_stage.cost_base_unit.remark }}</div>
                  </div>
                </td>
                <td><gtc-number :read-only="true" v-model="unit_estimation_curr_stage.cost_base_unit.poc_cost" /></td>
                <td><gtc-number :read-only="true" v-model="unit_estimation_curr_stage.cost_base_unit.mp_cost" /></td>
                <td class="px-2">–</td>
              </tr>
              <tr>
                <td>(C) Additional Material Cost / Per unit</td>
                <td><gtc-number :read-only="true" v-model="unit_estimation_curr_stage.additional_material_cost.poc_cost" /></td>
                <td><gtc-number :read-only="true" v-model="unit_estimation_curr_stage.additional_material_cost.mp_cost" /></td>
                <td><gtc-text-box :read-only="true" class="" v-model="unit_estimation_curr_stage.additional_material_cost.remark" /></td>
              </tr>
              <tr>
                <td>(D) Additional MVA Cost / Per unit</td>
                <td><gtc-number :read-only="true" class="text-right" v-model="unit_estimation_curr_stage.additional_mva_cost.poc_cost" /></td>
                <td><gtc-number :read-only="true" v-model="unit_estimation_curr_stage.additional_mva_cost.mp_cost" /></td>
                <td><gtc-text-box :read-only="true" v-model="unit_estimation_curr_stage.additional_mva_cost.remark" /></td>
              </tr>
            </tbody>
            <tfoot>
              <tr>
                <td>Total cost/Per unit (=A+B+C+D)</td>
                <td class="text-right font-weight-normal font-size-base">{{ unit_estimation_total_poc_cost_curr_stage | comma }}</td>
                <td class="text-right font-weight-normal font-size-base">{{ unit_estimation_total_mp_cost_curr_stage  | comma }}</td>
                <td></td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>
      <!--#endregion-->
      <!--#region Customize Quote Items-->
      <div class="stage-body-customize-quote-items">
        <div class="caption-label d-flex">
          <div>Customize Quote Items</div>
        </div>
        <div>
          <b-table small thead-class="thead-light text-dark"
                   :items="$attrs.quoteItemsMapping" :fields="nrePage.customizeQuoteItemsSetting">
            <template #cell(qty)="data">
              {{ data.item.qty | comma(0) }}
            </template>
            <template #cell(hq_cost)="data">
              {{ data.item.hq_cost | comma }}
            </template>
          </b-table>
        </div>
      </div>
      <!--#endregion-->
      <!--#region Customize NRE/Cost Notification-->
      <div class="stage-body-rsm-comments-and-conclusions border-bottom pb-4 mb-4">
        <div class="caption-label d-flex">
          <div>Customize NRE/Cost Notification</div>
        </div>
        <div>
          <gtc-froala :read-only="true" v-model="nrePage.nreData.page_object.mail_template_exclude_regexp" class="bg-white border-0" />
        </div>
      </div>
      <!--#endregion-->
      <!--#region GTC Sales Comments and Conclusions-->
      <div class="stage-body-gtc-sales-comments-and-conclusions border-bottom pb-4 mb-4">
        <div class="caption-label d-flex">
          <div>GTC Sales Comments and Conclusions</div>
        </div>
        <div>
          <gtc-froala :read-only="true" v-model="nrePage.nreData.page_object.gtc_comment" />
        </div>
      </div>
      <!--#endregion-->
      <!--#region GRO RSM Comments and Conclusions-->
      <div class="stage-body-gro-rsm-comments-and-conclusions border-bottom pb-4 mb-4">
        <div class="caption-label d-flex">
          <div>RSM Comments and Conclusions</div>
        </div>
        <div>
          <gtc-froala :read-only="true" v-model="nrePage.nreData.page_object.rsm_comment" />
        </div>
      </div>
      <!--#endregion-->
      <!--#region GRO Sales Director Comments and Conclusions-->
      <div class="stage-body-gro-sales-comments-and-conclusions border-bottom pb-4 mb-4">
        <div class="caption-label d-flex">
          <div>Sales Director/Manager Comments and Conclusions</div>
        </div>
        <div>
          <gtc-froala :read-only="true" v-model="nrePage.nreData.page_object.sales_director_comment" />
        </div>
      </div>
      <!--#endregion-->
      <!--#region GRO Head Comments and Conclusions-->
      <div class="stage-body-gro-head-comments-and-conclusions">
        <div class="caption-label d-flex">
          <div>GRO Head Comments and Conclusions</div>
        </div>
        <div>
          <div v-if="$attrs.readOnly && nrePage.nreData.page_object.gro_head_comment.approval === 'Completed_'">
            <div class="d-inline-block bg-primary text-white">
              <span>Conditional Approved : </span>
              <span>{{ nrePage.nreData.page_object.gro_head_comment.update_date | dateTimeFormat }}</span>
            </div>
          </div>
          <gtc-froala :read-only="$attrs.readOnly" v-model="nrePage.nreData.page_object.gro_head_comment.content" />
        </div>
      </div>
      <!--#endregion-->
      <!--#region NEW!! Reject Reason Section-->
      <div v-if="$attrs.showReasonSection" class="stage-body-gtc-sales-comments-and-conclusions">
        <br />
        <div class="caption-label d-flex">
          <div>
            <span class="badge badge-danger" style="font-size: 16px;margin-bottom: 5px;">GRO Head Reject Reason</span>
          </div>
        </div>
        <div>
          <gtc-froala :read-only="true" v-model="nrePage.nreData.page_object.reject_reason" />
        </div>
      </div>
      <!--#endregion-->
    </div>
    <div class="fixed-bottom d-print-none" v-if="canWithdraw || !$attrs.readOnly">
      <div class="row py-3 bg-gray-150 px-4 border-top border-gray-550">
        <div class="col-auto ml-auto p-0"></div>
        <template v-if="!$attrs.readOnly">
          <div class="col-auto">
            <button type="button" class="btn btn-success min-w-6" @click="$emit('save')">Save</button>
          </div>
          <div class="col-auto border-left p-0 border-gray-550" style="width:1px"></div>
        </template>
        <div class="col-auto">
          <button type="button" class="btn btn-danger" v-if="!$attrs.readOnly && !nrePage.isSubmitted" @click="$emit('reject')">Reject</button>
          <button type="button" class="btn btn-primary" v-if="!$attrs.readOnly && !nrePage.isSubmitted" @click="$emit('conditionalApprove')">Conditional Approve</button>
          <button type="button" class="btn btn-primary" v-if="!$attrs.readOnly && !nrePage.isSubmitted" @click="$emit('approve')">Approve</button>
        </div>
      </div>
    </div>

    <!--#endregion-->
  </div>
</template>
<script>
  export default {
    data() {
      return {

      };
    },
    created() {
      let self = this;
    },
    computed: {
      pocRequired() {
        return this.nre_estimation_curr_stage.poc_required === 'Y';
      },

      canWithdraw() {
        let self = this;
        let isAwaiting = self.nrePage.nreData.espm_leader_status === 'Waiting' ||
          self.nrePage.nreData.espm_leader_status === 'W';
        return isAwaiting && self.$attrs.isSubmitted && self.$attrs.readOnly;
      },

      //#region -- Alias --

      stageNumber() {
        return this.$attrs.stageNumber;
      },
      createFunction() {
        return this.$attrs.createFunction;
      },
      skuItem() {
        return this.$attrs.skuItem;
      },
      nrePage: {
        get() {
          return this.$attrs.data;
        },
        set(value) {
          this.$attrs.data = value;
        }
      },
      basic_info_review: {
        get() {
          return this.nrePage.nreData.page_object.basic_info_review;
        },
        set(value) {
          this.nrePage.nreData.page_object.basic_info_review = value;
        }
      },
      proposal_files: {
        get() {
          return this.nrePage.nreData.page_object.proposal_files;
        },
        set(value) {
          this.nrePage.nreData.page_object.proposal_files = value;
        }
      },
      reference_files: {
        get() {
          return this.nrePage.nreData.page_object.reference_files;
        },
        set(value) {
          this.nrePage.nreData.page_object.reference_files = value;
        }
      },
      lead_time_notice: {
        get() {
          return this.nrePage.nreData.page_object.lead_time_notice;
        },
        set(value) {
          this.nrePage.nreData.page_object.lead_time_notice = value;
        }
      },
      quote_items: {
        get() {
          return this.nrePage.nreData.page_object.quote_items;
        },
        set(value) {
          this.nrePage.nreData.page_object.quote_items = value;
        }
      },

      nre_estimation_curr_stage: {
        get() {
          return this.nrePage.nreData.page_object.nre_estimation_curr_stage;
        },
        set(value) {
          this.nrePage.nreData.page_object.nre_estimation_curr_stage = value;
        }
      },
      unit_estimation_curr_stage: {
        get() {
          return this.nrePage.nreData.page_object.unit_estimation_curr_stage;
        },
        set(value) {
          this.nrePage.nreData.page_object.unit_estimation_curr_stage = value;
        }
      },
      nre_estimation_total_poc_cost_curr_stage() {
        let self = this;
        let cols = [
          self.nre_estimation_curr_stage.labor_cost.poc_cost,
          self.nre_estimation_curr_stage.test_sample.poc_cost,
          self.nre_estimation_curr_stage.job_cost.poc_cost,
          self.nre_estimation_curr_stage.regulation.regulation_others.poc_cost,
          self.nre_estimation_curr_stage.total_cost.poc_cost
        ];
        let result = _.round(_.sum(cols), 2);
        //self.nre_estimation_curr_stage.total_cost.poc_cost = result;
        return result;
      },
      nre_estimation_total_mp_cost_curr_stage() {
        let self = this;
        let cols = [
          self.nre_estimation_curr_stage.labor_cost.mp_cost,
          self.nre_estimation_curr_stage.test_sample.mp_cost,
          self.nre_estimation_curr_stage.job_cost.mp_cost,
          self.nre_estimation_curr_stage.regulation.regulation_others.mp_cost,
          self.nre_estimation_curr_stage.total_cost.mp_cost
        ];
        let result = _.round(_.sum(cols), 2);
        // self.nre_estimation_curr_stage.total_cost.mp_cost = result;
        return result;
      },
      unit_estimation_total_poc_cost_curr_stage() {
        let self = this;
        let cols = [
          self.unit_estimation_curr_stage.cost_base_unit.poc_cost,
          self.unit_estimation_curr_stage.additional_material_cost.poc_cost,
          self.unit_estimation_curr_stage.additional_mva_cost.poc_cost
        ];
        let result = _.round(_.sum(cols), 2);
        self.unit_estimation_curr_stage.total_cost.poc_cost = result;
        return result;
      },
      unit_estimation_total_mp_cost_curr_stage() {
        let self = this;
        let cols = [
          self.unit_estimation_curr_stage.nre_amortization.nre_amortization_cost,
          self.unit_estimation_curr_stage.cost_base_unit.mp_cost,
          self.unit_estimation_curr_stage.additional_material_cost.mp_cost,
          self.unit_estimation_curr_stage.additional_mva_cost.mp_cost
        ];
        let result = _.round(_.sum(cols), 2);
        self.unit_estimation_curr_stage.total_cost.mp_cost = result;
        return result;
      },

      //#endregion
      //#region -- Price --

      jobCost() {
        return {
          poc_cost: _.sum(_.map(this.nre_estimation_curr_stage.job_cost, item => { return _.get(item, 'poc_cost', 0); })),
          mp_cost: _.sum(_.map(this.nre_estimation_curr_stage.job_cost, item => { return _.get(item, 'mp_cost', 0); }))
        };
      },
      regulation() {
        return {
          poc_cost: _.sum(_.map(this.nre_estimation_curr_stage.regulation, item => { return _.get(item, 'poc_cost', 0); })),
          mp_cost: _.sum(_.map(this.nre_estimation_curr_stage.regulation, item => { return _.get(item, 'mp_cost', 0); }))
        };
      },

      test_sample_mp_cost() {
        let self = this;
        return self.nre_estimation_curr_stage.test_sample.mp_cost;
      },

      //#endregion
    },
    methods: {

    }
  }
</script>



// WEBPACK FOOTER //
// src/components/GROHeadConfirm.vue